// Восстановление/удаление позиций справочников (выделено из reference.api.ts планом 108, Ф4).
import { api } from '@/lib/api';

// --- Generic restore/hard-delete (reference-admin) --------------------------
// entity: direction|level|category|age_group|hall|rental_condition|deal_source|
//         deal_stage|legal_entity|group|employee|branch
export type ReferenceEntity =
  | 'direction'
  | 'level'
  | 'category'
  | 'age_group'
  | 'hall'
  | 'rental_condition'
  | 'deal_source'
  | 'deal_stage'
  | 'stage_reason'
  | 'legal_entity'
  | 'group'
  | 'employee'
  | 'branch'
  | 'discount';

/** Вернуть позицию справочника из архива. */
export function restoreReference(entity: ReferenceEntity, id: string): Promise<void> {
  return api.post<void>(`/reference-admin/${entity}/${id}/restore`, {});
}

/** Удалить позицию справочника навсегда (409 если есть связи). */
export function deleteReference(entity: ReferenceEntity, id: string): Promise<void> {
  return api.delete<void>(`/reference-admin/${entity}/${id}`);
}
